(function() {
  const TAG = 'mistore-welcome-popup';

  class MistoreWelcomePopup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      // Read dataset in connectedCallback, not constructor —
      // attributes may not be parsed yet during element upgrade.
      this.popupId = this.dataset.popupId || 'default';
      this.cookieName = 'ai_welcome_popup_' + this.popupId + '_shown';
      this.delay = parseInt(this.dataset.delay) || 0;

      // Event delegation: i figli potrebbero non essere ancora nel DOM
      // quando connectedCallback gira (custom element upgrade durante il parsing).
      this.addEventListener('click', (event) => {
        const target = event.target;
        if (
          target.closest('[data-popup-close]') ||
          target.closest('[data-popup-dismiss]') ||
          target.closest('[data-popup-overlay]')
        ) {
          this.closePopup();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('active')) {
          this.closePopup();
        }
      });

      const isDesignMode = window.Shopify && window.Shopify.designMode;

      if (isDesignMode) {
        this.showPopup();
        return;
      }

      if (!this.hasBeenShown()) {
        setTimeout(() => {
          this.showPopup();
        }, this.delay);
      }
    }

    hasBeenShown() {
      return document.cookie.split('; ').find((row) => row.startsWith(this.cookieName + '='));
    }

    setCookie() {
      const expiryDate = new Date();
      expiryDate.setFullYear(expiryDate.getFullYear() + 1);
      document.cookie =
        this.cookieName + '=true; expires=' + expiryDate.toUTCString() + '; path=/; SameSite=Lax';
    }

    showPopup() {
      this.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    closePopup() {
      this.classList.remove('active');
      document.body.style.overflow = '';
      const isDesignMode = window.Shopify && window.Shopify.designMode;
      if (!isDesignMode) {
        this.setCookie();
      }
    }
  }

  if (!customElements.get(TAG)) {
    customElements.define(TAG, MistoreWelcomePopup);
  }
})();